import { Theme, useTheme as useMUITheme } from '@mui/material';

export const useTheme = () => useMUITheme();
export type { Theme };
